import styled from 'styled-components';
import React from 'react';

export interface TableProps {
  readonly children: React.ReactNode;
}

const StyledTable = styled.table`
  width: 100%;
  border-spacing: 0;
  font-size: inherit;
`;

export function Table({children}: TableProps): JSX.Element {
  return (
    <StyledTable>
      <tbody>{children}</tbody>
    </StyledTable>
  );
}
